var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{staticStyle:{"width":"100%"}},[_c('map-tool-list',{attrs:{"uiid":_vm.uiid}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }